import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import './LeaderboardCongratsBanner.css';

/**
 * Green congratulations ribbon.
 * Tournament: blank ribbon + live `leaderboardTitle`.
 * Rap Fire / Housie: baked-in ribbon art, label for accessibility only.
 */
const LeaderboardCongratsBanner = ({ label, dynamicLabel = false }) => (
  <div
    className={`lb-congrats${dynamicLabel ? ' lb-congrats--dynamic' : ''}`}
    aria-label={label}
  >
    <img
      className="lb-congrats__ribbon"
      src={
        dynamicLabel
          ? IMAGE_CONSTANTS.V2_LEADERBOARD_CONGRATS_RIBBON
          : IMAGE_CONSTANTS.V2_LEADERBOARD_CONGRATS_RIBBON_STATIC
      }
      alt=""
      aria-hidden="true"
      draggable={false}
    />
    {dynamicLabel ? (
      <p className="lb-congrats__text" style={{ fontFamily: FONTS.INTER_EXTRABOLD }}>
        {label}
      </p>
    ) : (
      <span className="lb-congrats__text sr-only">{label}</span>
    )}
  </div>
);

LeaderboardCongratsBanner.propTypes = {
  label: PropTypes.string.isRequired,
  dynamicLabel: PropTypes.bool,
};

export default LeaderboardCongratsBanner;
